import {
	SET_ERROR_LIST,
	CLEAR_ERROR_LIST,
	CLEAR_ERROR_ELEMENTS_LIST,
	SET_ERROR_DETAIL_LIST,
	SHOW_ERROR_DETAILS
} from '../actionTypes/ErrorSetupActionTypes';

export const setErrorListAction = (errorList)=>{
	return{
		type:SET_ERROR_LIST,
		payload:errorList
	}
}

export const clearErrorListAction = (errorList=[])=>{
	return{
		type:CLEAR_ERROR_LIST,
		payload:errorList
	}
}

export const clearErrorElementsListAction = ()=>{
	//console.log('clearErrorElementsListAction==',clearErrorElementsListAction)
	return{
		type:CLEAR_ERROR_ELEMENTS_LIST,
		payload:[]
	}
}

export const setErrorDetailListAction = (errorDetailsList)=>{
	return{
		type:SET_ERROR_DETAIL_LIST,
		payload:errorDetailsList
	}
}

export const showErrorDetailsAction = ()=>{	
	return{
		type:SHOW_ERROR_DETAILS,
		payload:{}
	}
}